var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mb-6"},[_vm._v("Payments")]),_c('p',[_vm._v("Here you can find all the payments that were made by the skillToon users.")]),_c('TransactionsTable')],1)}
var staticRenderFns = []

export { render, staticRenderFns }